import { Component, h } from '@stencil/core';
import "../.././stories/Components/MessageBubble/DocumentMessageBubble/DocumentMessageBubble"
@Component({
  tag: 'chat-document-message-bubble',
  shadow: true
})
 class ChatDocumentMessageBubble {

  render() {
    return (
      <div>
        <document-message
          bgColor='#EFF1FA'
          borderRadius="6px"
          time={new Date().toISOString()}
          docName='Somesomsomesomesome'
          width="200px"
          height="80px"
          documentNamePadding="10px 7px"
          padding="10px"
        >
        </document-message>
      </div>
    );
  }
}

export { ChatDocumentMessageBubble };
